import React from 'react';

import get from 'lodash/get';

import { DescriptionList, DescriptionItem } from '@gogame/components';

export default ({ data }) => {
  const engagementEvents = get(data, 'engagementEvents', []);
  if (!engagementEvents.length) {
    return null;
  }

  return (
    <DescriptionList disableGutters data={data}>
      {engagementEvents.map((row, index) => (
        <DescriptionItem
          label={row.name}
          value={row.value ? 'Yes' : 'No'}
          key={index}
        />
      ))}
    </DescriptionList>
  );
};
